import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import KivaProxy from "@/utils/kivaProxy/src";
import CannedResponseModal from "@/components/CannedResponseModal";
import { inboxMessageModel } from "@/models/inboxMessageModel";
import { InboxMessageTransformer } from "@/transformers/InboxMessageTransformer";
import { temporaryImageUpload } from "@/utils/temporaryImageUpload";
import { ThreadTransformer } from "@/transformers/ThreadTransformer";
import thredMixin from "@/mixins/thread";
import timeCounterMixin from "@/mixins/timeCounter.js";
import emailMixin from "@/mixins/email.js";
import moment from 'moment';
export default {
  name: "ReplyDrawer",
  props: {
    value: {},
    excerpt: "",
    thread: {},
    model: {
      type: Object,
      default: {}
    },
    isForward: {
      type: Boolean,
      default: false
    },
    timeEnrtyField: {
      type: Boolean,
      default: false
    },
    threadId: [Number, String]
  },
  mixins: [thredMixin, timeCounterMixin, emailMixin],
  components: {
    CannedResponseModal: CannedResponseModal,
    KvAccountMemberSelect: function KvAccountMemberSelect() {
      return import("@/components/kiva/KvAccountMemberSelect");
    },
    kvContacts: function kvContacts() {
      return import("@/components/kiva/remote-search/kvContactsEmail");
    },
    KvTimeSelect: function KvTimeSelect() {
      return import("@/components/kiva/KvTimeSelect");
    }
  },
  data: function data() {
    return {
      editorConfig: {
        toolbarExternal: "#editor-toolbar",
        focus: true,
        source: false,
        plugins: ["fontcolor", "alignment", 'blockcode', "table", "imageposition", "clips", "selector", "inlineformat", "removeformat", "underline", "myplugin", "extendedcodeblock", "paneloptions"],
        // fontcolors: [
        //       '#000', '#333', '#555', '#777', '#999', '#aaa',
        //       '#bbb', '#ccc', '#ddd', '#eee', '#f4f4f4'
        //   ],

        format: ["p", "h1", "h2", "h3", "h4", "ul", "ol"],
        inlineformat: {
          items: ["u", "sup", "sub", "mark", "kbd", "codex", "bluespan", "greenspan", "yellowspan", "redspan", "grayspan", "bluebold", "greenbold", "yellowbold", "redbold"],
          itemsObj: {
            bluespan: {
              title: "<span style='color: #fff; background: #2887eb; padding: 2px 8px; border-radius: 3px;'>Bluespan</span> ",
              params: {
                tag: "span",
                attr: {
                  "class": "bluespan"
                }
              }
            },
            greenspan: {
              title: "<span style='color: #fff; background: #67C23A; padding: 2px 8px; border-radius: 3px;'>Greenspan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            yellowspan: {
              title: "<span style='color: #fff; background: #E6A23C; padding: 2px 8px; border-radius: 3px;'>Yellowpan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "bluespan"
                }
              }
            },
            redspan: {
              title: "<span style='color: #fff; background: #f64e60; padding: 2px 8px; border-radius: 3px;'>Redspan</span>",
              params: {
                tag: "span",
                attr: {
                  class: "redspan"
                }
              }
            },
            grayspan: {
              title: "<span style='color: #465669; background: #eaeef7; padding: 2px 8px; border-radius: 3px;'>Graypan</span> ",
              params: {
                tag: "span",
                attr: {
                  class: "grayspan"
                }
              }
            },
            bluebold: {
              title: "<b style='color: #2887eb;'>Bluebold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "bluebold",
                  "data-type": "my-mark"
                }
              }
            },
            greenbold: {
              title: "<b style='color: #67C23A;'>Greenbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "greenbold",
                  "data-type": "my-mark"
                }
              }
            },
            yellowbold: {
              title: "<b style='color: #E6A23C;'>Yellowbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "yellowbold",
                  "data-type": "my-mark"
                }
              }
            },
            redbold: {
              title: "<b style='color: #f64e60;'>Redbold</b> ",
              params: {
                tag: "b",
                attr: {
                  class: "redbold",
                  "data-type": "my-mark"
                }
              }
            },
            codex: {
              title: "<b style='color: #000;'>Code</b>",
              params: {
                tag: "span",
                attr: {
                  class: "kv-code-block language-csharp language-javascript language-sql language-auto",
                  "data-type": "code"
                }
              }
            }
          }
        },
        pasteKeepClass: ['pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'blockquote', 'p', 'figure', 'figcaption'],
        pasteKeepStyle: ['p', 'a', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'blockquote', 'p', 'figure', 'figcaption'],
        imageUpload: temporaryImageUpload,
        button: {
          hideTooltip: true
        },
        buttonsAddAfter: {
          after: 'deleted',
          buttons: ['fontcolor']
        }
      },
      excerptMutable: this.excerpt,
      fromData: [],
      keyUploadForm: 'keyUploadForm',
      threadCreated: true,
      loading: false,
      isVisible: true,
      forward: {
        to: null,
        from: null
      },
      contactKeys: "contactKeys",
      mutableValue: this.value,
      showFileUpload: false,
      cannedResponseModal: false,
      messageModel: inboxMessageModel({
        thread: this.thread
      }),
      quickSaveonComplete: {
        hours: 0,
        minutes: 0
      },
      modelThread: this.model
    };
  },
  created: function created() {
    this.showFileUpload = false;
    if (!this.excerpt) {
      this.getModel();
      var excerpt = this.$store.state.common.INBOX_PREFERENCES;
      this.excerptMutable = excerpt ? excerpt.signatureTemplate : "";
      this.messageModel.message = "<br>".concat(this.excerptMutable);
    }
    if (this.timeEnrtyField && "THREAD_" + this.threadId == this.$store.state.tasks.timeCounter.uniq) {
      var tm = Math.ceil(this.$store.state.tasks.timeCounter.time / 60);
      var h = Math.floor(tm / 60);
      var m = tm % 60;
      this.quickSaveonComplete.minutes = m;
      this.quickSaveonComplete.hours = h;
      this.quickSaveonComplete.time = this.$store.state.tasks.timeCounter.time;
      this.quickSaveonComplete.isCounter = true;
      this.showFileUpload = false;
      // uploadFile
    }

    if (this.threadId) {
      this.getModel();
      this.showFileUpload = false;
      // uploadFile
    }
  },

  methods: {
    checkBeforeUpload: function checkBeforeUpload(file) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (_this.messageModel.recordId) {
          resolve(_this.messageModel.recordId);
        } else {
          if (_this.threadCreated) {
            _this.threadCreated = false;
            _this.sendReply(1).then(resolve).catch(reject);
          } else {
            setTimeout(function () {
              resolve(_this.checkBeforeUpload(file));
            }, 500);
          }
        }
      });
    },
    getModel: function getModel() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this2.threadId) {
                _context.next = 4;
                break;
              }
              _this2.loading = true;
              _context.next = 4;
              return new KivaProxy({
                endpoint: "inbox/thread"
              }).find(_this2.threadId).then(function (response) {
                // console.log("response",response)
                var record = ThreadTransformer.fetch(response.record);
                Object.assign(_this2.modelThread, record);
              }).catch(function (err) {
                console.log("err", err);
                _this2.loading = false;
              }).finally(function () {
                _this2.loading = false;
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCommand: function handleCommand(command) {
      var draft = command == "draft" ? 1 : 0;
      if (draft == 0) {
        // 1	Open
        // 2	Waiting
        // 3	Closed
        // 4	Spam

        // 1	New	
        // 2	Feasibility	
        // 3	Waiting for Budget and Project Plan	
        // 4	Waiting for Customer Approval	
        // 5	Approved	
        // 6	In Progress	
        // 7	Completed	
        // 8	Cancelled

        if (this.model.requestType.value == 1) {
          var case_status = command == "hold-third-party" || command == "hold-customer" || command == "hold-internal" ? 2 : command == "open" ? 1 : command == "close" ? 3 : 0;
          var hold_reason = command == "hold-third-party" ? 2 : command == "hold-customer" ? 1 : command == "hold-internal" ? 3 : null;
          if (case_status == 3) {
            this.modelThread.closedOn = moment().format("YYYY-MM-DD hh:mm:ss");
          }
          if (case_status) {
            this.modelThread.caseStatus.value = case_status;
            this.modelThread.holdReason = {
              value: hold_reason
            };
            new KivaProxy({
              endpoint: "inbox/thread"
            }).update({
              record_id: this.threadId,
              case_status: case_status,
              closedOn: this.modelThread.closedOn,
              hold_reason: hold_reason
            });
            this.$emit("setStatus", case_status);
          }
        } else if (this.model.requestType.value == 2) {
          var request_status = command == "completed" ? 7 : command == "cancelled" ? 8 : command == "in-progress" ? 6 : command == "feasibility" ? 2 : command == "project-plan" ? 3 : command == "customer-approval" ? 4 : 0;
          if (request_status == 7 || request_status == 8) {
            this.modelThread.closedOn = moment().format("YYYY-MM-DD hh:mm:ss");
          }
          if (request_status) {
            this.modelThread.requestStatus.value = request_status;
            new KivaProxy({
              endpoint: "inbox/thread"
            }).update({
              record_id: this.threadId,
              request_status: request_status,
              closedOn: this.modelThread.closedOn
            });
            this.$emit("setRequestStatus", request_status);
          }
        } else if (this.model.requestType.value == 3) {
          var sales_inquiry_status = command == "unqualified" ? 2 : command == "converted-lead" ? 3 : 0;
          if (sales_inquiry_status == 3) {
            this.modelThread.closedOn = moment().format("YYYY-MM-DD hh:mm:ss");
          }
          if (sales_inquiry_status) {
            this.modelThread.salesInquiryStatus.value = sales_inquiry_status;
            new KivaProxy({
              endpoint: "inbox/thread"
            }).update({
              record_id: this.threadId,
              sales_inquiry_status: sales_inquiry_status,
              closedOn: this.modelThread.closedOn
            });
            this.$emit("setSalesInquiryStatus", sales_inquiry_status);
          }
        }
      }
      this.sendReply(draft);
    },
    sendReply: function sendReply() {
      var _this3 = this;
      var draft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var method = "create";
      if (this.messageModel.recordId) {
        method = "update";
      }
      this.messageModel.sendDate = new Date();
      this.messageModel.draft = draft;
      this.messageModel.cc = this.modelThread.cc ? this.modelThread.cc.map(function (k) {
        return k && k.target_email ? k.target_email : k;
      }) : [];
      this.messageModel.cc = this.messageModel.cc.join(",");
      this.messageModel.bcc = this.modelThread.bcc ? this.modelThread.bcc.map(function (k) {
        return k && k.target_email ? k.target_email : k;
      }) : [];
      this.messageModel.bcc = this.messageModel.bcc.join(",");
      this.messageModel.strippedMessage = this.$refs.redactor.getStrippedContent();
      return new Promise(function (resolve, reject) {
        new KivaProxy({
          endpoint: "inbox/message"
        })[method](JSON.parse(JSON.stringify(InboxMessageTransformer.send(_this3.messageModel)))).then(function (response) {
          if (!draft) {
            _this3.mutableValue = false;
            _this3.$emit("success");
            _this3.reset();
          } else {
            _this3.messageModel.recordId = response.records[0].record_id;
          }
          if (_this3.timeEnrtyField == true) {
            if (_this3.quickSaveonComplete && _this3.quickSaveonComplete.hours || _this3.quickSaveonComplete.minutes) {
              var counter = _this3.getCounter();
              var _modelThread = _this3.modelThread;
              _modelThread.uniq = "THREAD_" + _this3.modelThread.id;
              _modelThread.object_type = "THREAD";
              _modelThread.record_id = _this3.modelThread.id;
              _this3.saveTimeEntry({
                isRunning: counter.isRunning,
                account_name: _modelThread.account_name ? _modelThread.account_name : null,
                project: _modelThread.project ? _modelThread.project : null,
                section: null,
                task: null,
                event: null,
                thread: _modelThread.record_id,
                record_id: _modelThread.record_id,
                time: _this3.quickSaveonComplete.hours * 60 * 60 + _this3.quickSaveonComplete.minutes * 60
              }, _modelThread);
            } else if (modelThread.record_id == _this3.timeCounter.record_id) {
              _this3.saveTimeEntry(null, object);
            }
          }
          resolve(response.records[0].record_id);
        }).catch(reject);
      });
    },
    sendForward: function sendForward() {
      var _this4 = this;
      var datax = new FormData();
      var data = {
        appId: "inbox",
        modelId: "thread"
      };
      data.from = this.forward.from;
      data.to = this.forward.to && this.forward.to[0] ? this.forward.to[0].target_email ? this.forward.to[0].target_email : this.forward.to[0] : null;
      var cc = [];
      var bcc = [];
      this.forward.to.forEach(function (e) {
        if (e && e.target_email) {
          cc.push(e.target_email);
        } else {
          cc.push(e);
        }
      });
      if (cc[1]) {
        data.cc = cc ? cc.join(",") : "";
      }
      if (bcc[0]) {
        data.bcc = null;
      }
      data.subject = "Fw:" + this.model["subject"];
      // data.includeTemplate = null;
      // data.template = null;
      // data.scheduleDate = null;
      // data.body_html = this.$refs.redactor.getStrippedContent();
      // console.log(" this.messageModel", this.messageModel)
      // console.log(" this.forward", this.forward)
      data.body_html = this.messageModel.message;

      // data.append('to',  this.model.to.target_email);
      Object.keys(data).forEach(function (key) {
        var value = data[key];
        datax.append(key, value);
      });
      if (this.$refs.files && this.$refs.files.uploadFiles.length) {
        this.$refs.files.uploadFiles.forEach(function (file) {
          if (!file.defaultTemplate) {
            datax.append("attachment[]", file.raw);
          }
        });
      }
      new KivaProxy({
        endpoint: "kvc/message/email",
        driver: "base"
      }).submit("post", "kvc/message/email", datax).then(function (response) {
        if (response.success) {
          _this4.mutableValue = false;
          _this4.$notify({
            title: "Success",
            message: "Succesfully sended.",
            type: "success"
          });
        } else {
          _this4.$notify({
            title: "Failed",
            message: _this4.$t("There is a problem. Try again later."),
            type: "warning"
          });
        }
      });
    },
    updateContent: function updateContent(_ref) {
      var content = _ref.content;
      this.messageModel.message = content;
    },
    reset: function reset() {
      this.messageModel = inboxMessageModel({
        thread: this.thread
      });
    },
    uploadFile: function uploadFile(_ref2) {
      var _this5 = this;
      var file = _ref2.file;
      this.checkBeforeUpload(file).then(function (messageId) {
        return new Promise(function (resolve, reject) {
          var data = new FormData();
          data.append("file", file);
          new KivaProxy({
            endpoint: "inbox/message/".concat(messageId, "/attachment")
          }).submit("post", "inbox/message/".concat(messageId, "/attachment"), data).then(resolve).catch(function (err) {
            _this5.$message.error(err.description);
            reject(new Error(err.description));
          });
          _this5.threadCreated = true;
        });
      });
    }
  },
  watch: {
    threadId: function threadId(val) {
      // console.log("1",val)
      this.messageModel = inboxMessageModel({
        thread: this.thread
      });
    },
    value: function value(val) {
      this.mutableValue = val;
      this.showFileUpload = false;
    },
    mutableValue: function mutableValue(val) {
      var _this6 = this;
      this.showFileUpload = false;
      this.keyUploadForm = 't' + Math.random(99, 99999);
      if (val) {
        if (this.excerpt) {
          this.messageModel.message = "<br>".concat(this.excerpt);
        }
        setTimeout(function () {
          if (_this6.$refs.redactor) {
            return _this6.$refs.redactor.redactor.editor.startFocus();
          }
        }, 50);
      }
      this.$emit("input", val);
    }
  }
};